import i18n from "i18n"

export const booleanToName = (
  value,
  options = {
    positive: i18n.t("yes"),
    negative: i18n.t("no"),
  }
) => (value ? options.positive : options.negative)
